import { componentSpacing01 } from '../../tokens';
var colors = {
  approved: '$color.success.light',
  denied: '$color.error.lighter',
  new: '$color.warning.light',
  enabled: '$color.primary.lightest'
};
export var tagDefaultTheme = {
  Root: {
    base: {},
    approved: {
      backgroundColor: colors.approved,
      borderColor: colors.approved
    },
    denied: {
      backgroundColor: colors.denied,
      borderColor: colors.denied
    },
    new: {
      backgroundColor: colors.new,
      borderColor: colors.new
    },
    enabled: {
      backgroundColor: colors.enabled,
      borderColor: colors.enabled,
      paddingRight: componentSpacing01
    }
  },
  Typography: {
    base: {},
    enabled: {
      marginRight: componentSpacing01
    }
  }
};